import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EnvironmentService} from '../../services/environment.service';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {OrdersPacket} from '../../models/order-packet.model';
import {CommonModule} from '@angular/common';
import {firstValueFrom, Subject, takeUntil} from 'rxjs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharePanelComponent} from '../share-panel/share-panel.component';

// declare var $: any;
declare var Snackbar: any;
declare var $: any;

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, SharePanelComponent],
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private loader: GlobalLoaderService,
    private renderer: Renderer2,
    private translate: TranslateService,
    public env: EnvironmentService,
    private activatedRoute: ActivatedRoute,
    private api: ApiAgentService) {
  }

  // @ts-ignore
  get statusLabel() {
    switch (this.status) {
      case 'all':
        return 'All Invoices List';
      case 'pending':
        return 'Pending Invoices';
      case 'ordered':
        return 'Orders List';
      case 'paidInvoice':
        return 'Paid Invoices';
      case 'completed':
        return 'Completed Invoices';
      case 'canceled':
        return 'Canceled Invoices';
      default:
        return 'Invoices List';
    }
  }

  private unsubscribe$ = new Subject<void>();

  loading: any;
  loadingOrder: boolean;
  loadingOrderNumber: string;
  selectedOrder: OrdersPacket;
  @ViewChild('invoicesList') invoicesList: ElementRef;
  @ViewChild('searchModal') searchModal: ElementRef;
  orders: OrdersPacket[];
  ordersList: OrdersPacket[];
  orderShareLink: any;
  status: any;
  private statusLabels = [];
  private paymentMethods = [];

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;
  @ViewChild('searchInput', {static: false}) searchInput: ElementRef;
  @ViewChild('orderShareLinkModal', {static: false, read: ElementRef}) orderShareLinkModal: ElementRef;
  @ViewChild('dropdownToggle', {static: false}) dropdownToggle: ElementRef;
  pageSize = 20;
  searchWord = '';
  loadingMore = false;

  private timer: any;
  refundReason: any;

  private static showToast(msg: any) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  checkPermission() {
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      const perms = this.env.checkPermission(params.type, params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isManager = perms.isManager;
      this.isMerchant = perms.isMerchant;
    });
  }

  ngAfterViewInit() {
    this.initializeDropdown();
  }

  toggleDropdown() {
    const dropdownMenu = this.dropdownToggle.nativeElement.nextElementSibling;
    const isExpanded = this.dropdownToggle.nativeElement.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.renderer.removeClass(dropdownMenu, 'show');
      this.renderer.setAttribute(this.dropdownToggle.nativeElement, 'aria-expanded', 'false');
    } else {
      this.renderer.addClass(dropdownMenu, 'show');
      this.renderer.setAttribute(this.dropdownToggle.nativeElement, 'aria-expanded', 'true');
    }
  }

  async onScrollInvoices() {
    console.log('scrolling');
    const scrollPosition = this.invoicesList.nativeElement.scrollTop + this.invoicesList.nativeElement.clientHeight;
    const scrollHeight = this.invoicesList.nativeElement.scrollHeight;
    if (scrollPosition >= scrollHeight - 1) {
      // get the page from the size of the ordersList where the size is pageSize.
      if (!this.loadingMore) {
        const page = Math.ceil(this.ordersList.length / this.pageSize) + 1;
        await this.loadMoreData(page);
      }
    }
  }

  initializeDropdown() {
    const dropdownElement = this.dropdownToggle.nativeElement;
    this.renderer.listen(dropdownElement, 'click', () => {
      const dropdownMenu = dropdownElement.nextElementSibling;
      const isExpanded = dropdownElement.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        this.renderer.removeClass(dropdownMenu, 'show');
        this.renderer.setAttribute(dropdownElement, 'aria-expanded', 'false');
      } else {
        this.renderer.addClass(dropdownMenu, 'show');
        this.renderer.setAttribute(dropdownElement, 'aria-expanded', 'true');
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      this.status = params['status'];
      this.orders = null;
      this.loadData().then();
      this.selectedOrder = null;
      // setTimeout(async () => {
      //   await this.initStatusLabels();
      //   await this.loadResources();
      //   $('.dropdown-toggle2').dropdown();
      // }, 1000);
      this.initPaymentLabels().then();
      this.initStatusLabels().then(() => {
        this.loadResources().then(() => {
          this.initializeDropdown();
        });
      });
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async loadData() {
    this.loading = true;
    // this.orders = await this.api.getOrdersByStatus(this.status);
    // this.ordersList = this.orders;
    await this.loadMoreData(1);
    this.checkPermission();
    console.log('line 139', this.loading);
    this.loading = false;
    console.log('line 141', this.loading);
  }

  async loadMoreData(page: number) {
    console.log('loading more data');
    this.loadingMore = true;
    let newOrders: any;
    if (this.searchWord) {
      newOrders = await this.api.getOrdersPageByStatusAndFilter(this.status, page, this.searchWord);
    } else {
      newOrders = await this.api.getOrdersPageByStatus(this.status, page);
    }
    console.log('new orders', newOrders);
    if (newOrders == null) {
      newOrders = [];
    }
    if (newOrders.length) {
      console.log('new orders length', newOrders.length);
      console.log('orders list line 160', this.ordersList);
      if (!this.ordersList) {
        this.ordersList = newOrders;
      } else {
        this.ordersList = [...this.ordersList, ...newOrders];
      }
    } else {
      this.ordersList = [];
    }
    this.loadingMore = false;
  }

  getTitle(receiverType: any) {
    switch (receiverType) {
      case  'MERCHANT_WALLET':
        return 'Merchant Wallet';
      case 'PAYLINK':
        return 'Transaction Fees';
      case 'SUBSCRIPTION_FEES':
        return 'Subscription Fees';
      case 'SETUP_FEES':
        return 'Setup Fees';
      case 'SUB_ACCOUNT_FEES':
        return 'Sub Account Fees';
      case 'CONSUMER_REFUND':
        return 'Refund Fees';
      case 'PAYLINK_VAT':
        return 'VAT Amount';
    }
  }

  getAmount(orderNumber: any, amount: any, receiverType: any) {
    switch (receiverType) {
      case  'MERCHANT_WALLET':
        return amount;
      case 'PAYLINK':
        if (!this.orders) {
          return amount;
        }
        const order = this.orders.find((value) => value.orderDetails.orderNumber === orderNumber).orderDetails;
        if (order.moneyTransfers != null) {
          const amounts = order.moneyTransfers.filter((v) => v.receiverType === 'PAYLINK' || v.receiverType === 'DONATION').map((v) => v.amount);
          amount = 0;
          for (const item of amounts) {
            amount += item;
          }
          return amount * 1;
        } else if (this.selectedOrder != null) {
          const amounts = this.selectedOrder.orderDetails.moneyTransfers.filter((v) => v.receiverType === 'PAYLINK' || v.receiverType === 'DONATION').map((v) => v.amount);
          amount = 0;
          for (const item of amounts) {
            amount += item;
          }
          return amount * 1;
        }
        return amount;
      case 'SUBSCRIPTION_FEES':
        return amount * 1;
      case 'SETUP_FEES':
        return amount * 1;
      case 'SUB_ACCOUNT_FEES':
        return amount * 1;
      case 'CONSUMER_REFUND':
        return amount * 1;
      case 'PAYLINK_VAT':
        return amount * 1;
      default:
        return null;
    }
  }

  shareOrder() {
    this.orderShareLink = this.env.getPaymentWebUrl() + '/pay/order/' + this.selectedOrder.orderDetails.orderNumber;
    this.showModal(this.orderShareLinkModal.nativeElement.firstElementChild);
  }

  closeModal() {
    this.hideModal(this.orderShareLinkModal.nativeElement.firstElementChild);
  }

  showModal(element: any) {
    console.log('element', element);
    console.log('element modal', $(element).modal);
    this.renderer.setStyle(element, 'display', 'block');
    this.renderer.addClass(element, 'show');
    this.renderer.setAttribute(element, 'aria-hidden', 'false');
    this.renderer.setAttribute(element, 'role', 'dialog');
    this.renderer.setAttribute(element, 'aria-modal', 'true');
    $(element).modal('show');
  }

  hideModal(element: any) {
    this.renderer.removeClass(element, 'show');
    this.renderer.setStyle(element, 'display', 'none');
    this.renderer.setAttribute(element, 'aria-hidden', 'true');
    $(element).modal('hide');
  }

  async printOrder() {
    // let uuid = uuidv4();
    const uuid = `00000000${this.selectedOrder.clientDetails.id % 100000000}`.slice(-8);
    window.open(this.env.getRest() + '/openApi/getPdfVatReport/' + this.selectedOrder.merchantDetails.id + '/' + uuid + '/' + this.selectedOrder.orderDetails.orderNumber);
  }

  async printReceipt() {
    const uuid = `00000000${this.selectedOrder.clientDetails.id % 100000000}`.slice(-8);
    window.open(this.env.getRest() + '/openApi/getPdfReceipt/' + this.selectedOrder.merchantDetails.id + '/' + uuid + '/' + this.selectedOrder.orderDetails.orderNumber);
  }

  calculateVat() {
    if (this.selectedOrder.orderDetails.products) {
      let vatAmount = 0;
      for (const p of this.selectedOrder.orderDetails.products) {
        const appliedVat = this.selectedOrder.orderDetails.vat !== 0 && p.appliedVat != null ? p.appliedVat : (this.selectedOrder.orderDetails.vat ? this.selectedOrder.orderDetails.vat : 0);
        vatAmount += this.pad(appliedVat * p.soldPrice);
      }
      return vatAmount;
    } else if (this.selectedOrder.orderDetails.vat) {
      return this.selectedOrder.orderDetails.vat * this.selectedOrder.orderDetails.amount;
    } else {
      return 0;
    }
  }

  async markOrderCompleted(o: any) {
    this.loading = true;
    try {
      await this.api.markOrderCompleted(o.orderDetails.orderNumber);
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('Order successfully changed')));
      window.location.reload();
    } catch (e) {
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('Order could not be changed. Try again')));
    } finally {
      this.loading = false;
    }
  }

  async cancelRefundOrder(o: any) {
    this.loading = true;
    try {
      await this.api.cancelRefundOrder(o.orderDetails.orderNumber);
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('Order refund request cancelled')));
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (e) {
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('The order refund request could not be canceled. Try again')));
    } finally {
      this.loading = false;
    }
  }

  async refundOrderCompleted(o: any) {
    this.loading = true;
    try {

      if (!this.refundReason) {
        OrdersComponent.showToast(await firstValueFrom(this.translate.get('The refund reason is required')));
        return;
      }

      await this.api.refundOrder(o.orderDetails.orderNumber, this.refundReason);
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('Order refund request created')));
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (e) {
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('The order could not be refunded. Try again')));
    } finally {
      this.loading = false;
    }
  }

  async cancelOrder(o: any) {
    this.loading = true;
    try {
      await this.api.cancelOrder(o.orderDetails.orderNumber);
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('Order cancelled successfully')));
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (e) {
      OrdersComponent.showToast(await firstValueFrom(this.translate.get('Order could not be cancelled. Try again')));
    } finally {
      this.loading = false;
    }
  }

  showSmallLoader(orderNumber: any): boolean {
    return this.loadingOrder && this.loadingOrderNumber === orderNumber;
  }

  selectOrder(o: any) {
    this.loadingOrder = true;
    this.loadingOrderNumber = o.orderDetails.orderNumber;

    const loadingInvoice = this.renderer.selectRootElement(`#loading-invoice-${o.orderDetails.orderNumber}`);
    const iconInvoice = this.renderer.selectRootElement(`#icon-invoice-${o.orderDetails.orderNumber}`);
    this.renderer.removeClass(loadingInvoice, 'd-none');
    this.renderer.addClass(loadingInvoice, 'd-block');
    this.renderer.addClass(iconInvoice, 'd-none');
    this.renderer.removeClass(iconInvoice, 'd-block');

    this.api.getOrder(o.orderDetails.orderNumber).then(order => {
      console.log('selected order is', order);
      this.selectedOrder = order;
      this.loadingOrder = false;
      this.renderer.removeClass(loadingInvoice, 'd-block');
      this.renderer.addClass(loadingInvoice, 'd-none');
      console.log('selected order is in line 473:', this.selectedOrder);
      this.renderer.addClass(iconInvoice, 'd-block');
      this.renderer.removeClass(iconInvoice, 'd-none');
      iconInvoice.innerHTML = '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>';
      console.log('selected order is in line 479:', this.selectedOrder);

    }).catch(() => {
      this.selectedOrder = null;
      this.loadingOrder = false;
    });
  }

  async initStatusLabels() {
    this.statusLabels['PENDING'] = await firstValueFrom(this.translate.get('Pending'));
    this.statusLabels['PAID_LINK'] = await firstValueFrom(this.translate.get('Paid Order'));
    this.statusLabels['PAID'] = await firstValueFrom(this.translate.get('Paid Invoice'));
    this.statusLabels['CANCELLED'] = await firstValueFrom(this.translate.get('Cancelled'));
    this.statusLabels['COMPLETED_ORDER'] = await firstValueFrom(this.translate.get('Completed'));
    this.statusLabels['COMPLETED_INVOICE'] = await firstValueFrom(this.translate.get('Completed'));
  }

  async initPaymentLabels() {
    this.paymentMethods['MADA'] = await firstValueFrom(this.translate.get('MADA'));
    this.paymentMethods['VISA'] = await firstValueFrom(this.translate.get('VISA'));
    this.paymentMethods['MasterCard'] = await firstValueFrom(this.translate.get('MasterCard'));
    this.paymentMethods['STCPAY'] = await firstValueFrom(this.translate.get('STC Pay'));
    this.paymentMethods['URPAY'] = await firstValueFrom(this.translate.get('URPay'));
    this.paymentMethods['AMEX'] = await firstValueFrom(this.translate.get('Amex'));
    this.paymentMethods['A2A'] = await firstValueFrom(this.translate.get('A2A'));
    this.paymentMethods['SADAD'] = await firstValueFrom(this.translate.get('Sadad'));
    this.paymentMethods['TABBY'] = await firstValueFrom(this.translate.get('Tabby'));
    this.paymentMethods['TAMARA'] = await firstValueFrom(this.translate.get('Tamara'));
  }


  private pad(num: any): number {
    num = num * 100;
    num = Math.round(num);
    return num / 100;
  }

  getStatusStyle(status: any) {
    if (status === 'PENDING') {
      return 'text-primary';
    } else if (status === 'PAID' || status === 'PAID_LINK') {
      return 'text-success';
    } else if (status === 'CANCELLED') {
      return 'text-warning';
    } else if (status === 'COMPLETED_ORDER' || status === 'COMPLETED_INVOICE') {
      return 'text-secondary';
    } else {
      return 'text-black';
    }
  }

  filterInvoices() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(async () => {
      this.ordersList = null;

      this.showModal(this.searchModal.nativeElement);

      setTimeout(async () => {
        this.searchWord = this.searchInput.nativeElement.value; // todo: test search word
        this.ordersList = await this.api.getOrdersPageByStatusAndFilter(this.status, 1, this.searchWord);
        console.log('filtered orders', this.ordersList);
        if (!this.ordersList) {
          this.ordersList = [];
        }
        console.log('filtered orders', this.ordersList);
        this.hideModal(this.searchModal.nativeElement);

      }, 1000);
    }, 2000);
  }

  getSubtotal(order: any) {
    let sum = 0;
    for (const p of order.orderDetails.products) {
      sum += (p.soldPrice * p.qty);
    }
    return sum;
  }

  getStatus(status: any) {
    return this.statusLabels[status];
  }

  getPaymentMethod(paymentNote: any) {
    if (paymentNote == null) {
      return 'N/A';
    }
    const lowerCase = paymentNote.toLowerCase();
    if (lowerCase.includes('stcpay')) {
      return this.paymentMethods['STCPAY'];
    } else if (lowerCase.includes('sadad')) {
      return this.paymentMethods['SADAD'];
    } else if (lowerCase.includes('visa')) {
      return this.paymentMethods['VISA'];
    } else if (lowerCase.includes('mastercard')) {
      return this.paymentMethods['MasterCard'];
    } else if (lowerCase.includes('mada')) {
      return this.paymentMethods['MADA'];
    } else if (lowerCase.includes('urpay')) {
      return this.paymentMethods['URPAY'];
    } else if (lowerCase.includes('amex')) {
      return this.paymentMethods['AMEX'];
    } else if (lowerCase.includes('a2a')) {
      return this.paymentMethods['A2A'];
    } else if (lowerCase.includes('tabby')) {
      return this.paymentMethods['TABBY'];
    } else if (lowerCase.includes('tamara')) {
      return this.paymentMethods['TAMARA'];
    }

  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/apps/invoice.css');
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/assets/js/apps/invoice.js');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
  }
}
